import { create } from 'zustand';

// ─── Inline types (will be refactored to shared imports later) ───

type BottomSheetState = 'closed' | 'peek' | 'half' | 'full';

type ActiveTab = 'discover' | 'events' | 'activities' | 'ai' | 'live' | 'me' | 'more';

// ─── Store ───

interface UIStore {
  // Bottom sheet (mobile map UX — venue list / detail)
  bottomSheetState: BottomSheetState;
  setBottomSheet: (state: BottomSheetState) => void;

  // Bottom navigation tab
  activeTab: ActiveTab;
  setActiveTab: (tab: ActiveTab) => void;

  // Filter sidebar / menu
  filterMenuOpen: boolean;
  setFilterMenuOpen: (open: boolean) => void;
  toggleFilterMenu: () => void;

  // Search overlay
  searchOpen: boolean;
  setSearchOpen: (open: boolean) => void;

  // Responsive breakpoint
  isMobile: boolean;
  setIsMobile: (v: boolean) => void;

  // My Reviews overlay
  myReviewsOpen: boolean;
  setMyReviewsOpen: (v: boolean) => void;

  // Toast / notification helpers (lightweight — for react-hot-toast integration)
  toastMessage: string | null;
  toastType: 'success' | 'error' | 'info' | null;
  showToast: (message: string, type?: 'success' | 'error' | 'info') => void;
  clearToast: () => void;
}

export const useUIStore = create<UIStore>((set) => ({
  bottomSheetState: 'peek',
  setBottomSheet: (bottomSheetState) => set({ bottomSheetState }),

  activeTab: 'discover',
  setActiveTab: (activeTab) => set({ activeTab }),

  filterMenuOpen: true,
  setFilterMenuOpen: (filterMenuOpen) => set({ filterMenuOpen }),
  toggleFilterMenu: () => set((s) => ({ filterMenuOpen: !s.filterMenuOpen })),

  searchOpen: false,
  setSearchOpen: (searchOpen) => set({ searchOpen }),

  isMobile: typeof window !== 'undefined' ? window.innerWidth < 768 : false,
  setIsMobile: (isMobile) => set({ isMobile }),

  myReviewsOpen: false,
  setMyReviewsOpen: (myReviewsOpen) => set({ myReviewsOpen }),

  toastMessage: null,
  toastType: null,
  showToast: (message, type = 'info') =>
    set({ toastMessage: message, toastType: type }),
  clearToast: () => set({ toastMessage: null, toastType: null }),
}));
